/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GraphNodeDto } from './GraphNodeDto';
import {
    GraphNodeDtoFromJSON,
    GraphNodeDtoFromJSONTyped,
    GraphNodeDtoToJSON,
    GraphNodeDtoToJSONTyped,
} from './GraphNodeDto';
import type { GraphEdgeDto } from './GraphEdgeDto';
import {
    GraphEdgeDtoFromJSON,
    GraphEdgeDtoFromJSONTyped,
    GraphEdgeDtoToJSON,
    GraphEdgeDtoToJSONTyped,
} from './GraphEdgeDto';

/**
 * 
 * @export
 * @interface RelationshipGraphDto
 */
export interface RelationshipGraphDto {
    /**
     * 
     * @type {Array<GraphNodeDto>}
     * @memberof RelationshipGraphDto
     */
    nodes?: Array<GraphNodeDto> | null;
    /**
     * 
     * @type {Array<GraphEdgeDto>}
     * @memberof RelationshipGraphDto
     */
    edges?: Array<GraphEdgeDto> | null;
}

/**
 * Check if a given object implements the RelationshipGraphDto interface.
 */
export function instanceOfRelationshipGraphDto(value: object): value is RelationshipGraphDto {
    return true;
}

export function RelationshipGraphDtoFromJSON(json: any): RelationshipGraphDto {
    return RelationshipGraphDtoFromJSONTyped(json, false);
}

export function RelationshipGraphDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipGraphDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nodes': json['nodes'] == null ? undefined : ((json['nodes'] as Array<any>).map(GraphNodeDtoFromJSON)),
        'edges': json['edges'] == null ? undefined : ((json['edges'] as Array<any>).map(GraphEdgeDtoFromJSON)),
    };
}

export function RelationshipGraphDtoToJSON(json: any): RelationshipGraphDto {
    return RelationshipGraphDtoToJSONTyped(json, false);
}

export function RelationshipGraphDtoToJSONTyped(value?: RelationshipGraphDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nodes': value['nodes'] == null ? undefined : ((value['nodes'] as Array<any>).map(GraphNodeDtoToJSON)),
        'edges': value['edges'] == null ? undefined : ((value['edges'] as Array<any>).map(GraphEdgeDtoToJSON)),
    };
}

